/**
 * Pre-compiled pt-BR messages for DraggableList
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  emptyMessage: `arrastar itens aqui`,
  removeButtonLabel: `remover item`,
};
